import React from "react";

const AdminManagement = () => {
  return <div>AdminManagement</div>
};

export default AdminManagement;
